<template>
  <modal
    :show="opened"
    class="modal__wrapper_less-blur modal__wrapper modal-info modal-info_narrow"
    @modal:close="close"
  >
    <h3 class="form__subtitle">Изменение E-mail</h3>
    <div class="form__description">
      <p>
        Вы указали почту <strong>{{ email }}</strong>. Если это не&nbsp;ваш адрес электронной почты, введите действующий адрес.
      </p>
    </div>
    <form @submit.prevent="submit">
      <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
        <template #errors>
          <div class="text-input__error">
            <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
          </div>
        </template>
      </smart-captcha>
      <div class="form-row form-row_1-col">
        <text-input
          label="E-mail*"
          type="text"
          name="email"
          v-model="$v.form.email.$model"
          :error="$v.form.email.$error"
        >
          <template #errors>
            <div class="text-input__error" v-if="$v.form.email.$error">
              <div v-if="!$v.form.email.required">
                Заполните поле
              </div>
              <div v-else-if="!$v.form.email.isValidUnicodeEmail">
                Неверный формат электронной почты
              </div>
              <div v-else-if="error">
                Эта электронная почта уже используется. Укажите другой адрес электронной почты.
              </div>
            </div>
          </template>
        </text-input>
      </div>

      <div class="form-row form-row_align-center">
        <button class="form__submit button button__lg button__blue" type="submit">
          Продолжить
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import TextInput from "./TextInput.vue";
import api from "../services/api";
import {emailToPunycode, isValidUnicodeEmail} from "../utils";
import SmartCaptcha from "./SmartCaptcha.vue";
import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";
export default {
  name: "SignUpStepEmailChangeModal",
  mixins: [SmartCaptchaMixin],
  components: {SmartCaptcha, TextInput},
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    email: {
      type: String
    }
  },
  data() {
    return {
      form: {
        email: '',
        captcha: ''
      },
    }
  },
  validations() {
    const form = {
      email: { required, isValidUnicodeEmail },
      captcha: {required},
    }
    return { form };
  },
  watch: {
    opened(val) {
      if (val) {
        this.clearInput();
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();

      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch('showLoader');

        try {
          const punycodeEmail = emailToPunycode(this.form.email);
          await api.changeEmail(punycodeEmail);

          this.$emit('change-email', punycodeEmail);
          this.$store.dispatch('hideErrorsBag');
          this.close();
        } catch (e) {
          this.$store.dispatch('setErrors', e);
          //await this.updateCaptchaOnError();
        } finally {
          this.$store.dispatch('hideLoader');
        }
      }
    },
    clearInput() {
      this.form.email = '';
      this.$v.$reset();
    }
  }
}
</script>
